import type { Supplement as PopsSupplement } from '@/types/pops'
import supplements_config, {
  type SupplementsConfig,
} from '@/config/supplements-config'

export const NO_SUPPLEMENT_NAME = 'no_addon'

export class Supplement {
  name: string
  displayName: string
  description: string
  config: SupplementsConfig[string]

  constructor(rawSupplement: PopsSupplement) {
    this.name = rawSupplement.name
    this.displayName = rawSupplement.display_name
    this.description = rawSupplement.description

    this.config = supplements_config[this.name]
  }
}
